import InputSearch from './InputSearch'
export default InputSearch
